// GENERATED FILE -- do not edit by hand.
// Regenerate with `npm run codegen:errors` (see frontend/package.json).
// Source: agent.shared.types.repository.UncommittedChangesError

import { RpcError, registerRpcError } from "@/app_store/rpc_error";

// Wire shape of this error: `code` discriminates the type, `message` is the
// human-readable text, and the remaining keys are the exception's own fields.
export interface UncommittedChangesErrorData {
    code: "UncommittedChangesError";
    message: string;
}

export class UncommittedChangesError extends RpcError {
    readonly code = "UncommittedChangesError" as const;

    constructor(data: UncommittedChangesErrorData) {
        super(data.code, data.message, data);
    }
}

registerRpcError("UncommittedChangesError", UncommittedChangesError);
